
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/important-shop-information",
      function () {
        return require("private-next-pages/important-shop-information.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/important-shop-information"])
      });
    }
  